export default __webpack_public_path__ + "static/team-member-06-370x455-217cbe7a3979bc66ac3b9d5ed863d52d.jpg";